<script setup lang="ts">
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import privacyText from '@/assets/legal/privacy-policy.txt?raw'
import { ChevronLeft } from 'lucide-vue-next'

const router = useRouter()
const { t } = useI18n()
const paragraphs = computed(() => privacyText.split(/\r?\n\s*\r?\n/).map((item) => item.trim()).filter(Boolean))

const goBack = () => {
  if (window.history.length > 1) {
    router.back()
    return
  }
  router.replace('/login')
}
</script>

<template>
  <div class="page-content h-screen flex flex-col p-4 max-w-4xl m-auto">
    <div class="mb-4 flex items-center justify-between gap-3">
      <div @click="goBack" class="flex items-center gap-2 cursor-pointer">
        <ChevronLeft :size="26" :stroke-width="2" />
        {{ t('agreement.back') }}
      </div>
      <h1 class="text-base font-semibold text-white md:text-lg">Privacy Policy</h1>
    </div>



    <article class="rounded-xl flex-1 overflow-y-auto bg-gray-900 p-5 text-sm leading-7 text-white/80 md:p-8 md:text-base">
      <p
        v-for="(paragraph, index) in paragraphs"
        :key="index"
        class="mb-4 whitespace-pre-wrap"
        :class="{ 'text-lg font-semibold text-white': /^(Introduction|What Information We Collect|How We Use Your Information|How We Share Your Information|International Data Transfers|Data Security|Data Retention|Information Relating to Minors|Privacy Policy Updates|Contact Us)$/.test(paragraph) || index === 0 }"
      >
        {{ paragraph }}
      </p>
    </article>
  </div>
</template>
